module.exports = __webpack_public_path__ + "static/media/S-2.801039e1.mp3";